import { getParameterByName } from '../../utils/toSearchParams';
import ProductDetailModal from '../Modal/ProductDetail';
import React, { useEffect, useState } from 'react';
import './ModalContainer.scss';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import MapDetailModal from '../Modal/MapDetailModal';
import { Product } from '../../store/products';

interface Props {
  location: any;
  productsByUrn: any;
  possibleBookingDates: any;
  addToBasket?: (product: Product, producturn: string) => void;
  removeFromBasket?: (basketEntryId: string, producturn: string) => void;
}

export const ModalContainer = ({
  location,
  productsByUrn,
  possibleBookingDates,
  addToBasket,
  removeFromBasket,
}: Props) => {
  const modalContent = getParameterByName('modalContent', location.search);
  const urn = getParameterByName('urn', location.search);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (modalContent === 'product' && urn) {
      setShow(true);
    } else if (modalContent === 'map' && urn) {
      setShow(true);
    } else {
      closeModal();
    }
  }, [location.search]);

  const renderModalContent = (modalContent) => {
    if (modalContent === 'map') {
      const lat = getParameterByName('lat', location.search);
      const lng = getParameterByName('lng', location.search);
      const urn = getParameterByName('urn', location.search);
      const currentProduct = productsByUrn && productsByUrn[urn];

      return (
        <div className='map-container'>
          <MapDetailModal
            latitude={lat}
            longitude={lng}
            product={currentProduct}
            addToBasket={addToBasket}
            removeFromBasket={removeFromBasket}
          />
        </div>
      );
    } else if (modalContent === 'product') {
      const currentProduct = productsByUrn && productsByUrn[urn];
      return (
        <ProductDetailModal
          location={location}
          product={currentProduct}
          possibleBookingDates={possibleBookingDates}
          productsByUrn={productsByUrn}
          addToBasket={addToBasket}
          removeFromBasket={removeFromBasket}
        />
      );
    }
  };

  const closeModal = () => {
    setShow(false);
    navigate({ search: '' });
  };

  return (
    <Modal
      className={`modal-container ${modalContent === 'product' ? 'map-detail-modal' : ''}`}
      dialogClassName={`${modalContent === 'product' ? 'map-detail-modal' : ''}`}
      backdropClassName={`${modalContent === 'product' ? 'map-detail-backdrop' : ''}`}
      show={show}
      onHide={closeModal}
      onEscapeKeyDown={closeModal}
      backdrop='static'
      size='lg'
      keyboard={true}
      centered
    >
      <>{modalContent && renderModalContent(modalContent)}</>
    </Modal>
  );
};
